import ChoicePills from "./ChoicePills";
import StepBlock from "./StepBlock";

const OPTIONS = [
  { value: "member", label: "學生" },
  { value: "school_cls", label: "班別" },
  { value: "grp", label: "社" },
];

export default function GroupBySelection({ groupBy, onChange }) {
  return (
    <StepBlock number="2" title="每一行代表" subtitle="排名的單位">
      <ChoicePills options={OPTIONS} value={groupBy} onChange={onChange} />
    </StepBlock>
  );
}
